export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}competency/competency/:id`;
    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        },
        updateSkill: {
            method: 'POST',
            url: `${url}/update-competence-skill`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/Competence/index.js